import * as uuid from "uuid";
import { Uuid } from "@/domains/global/identifiers";
import { ByteBuffer } from "@/modules/uuid/types";

export const _convertUuidToByteBuffer = (uuidString: Uuid): ByteBuffer => {
  const uuidBuffer = uuid.parse(uuidString);

  return uuidBuffer;
};
